import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';


import HomePage from '@/components/pages/HomePage';
import ContentPage from '@/components/pages/ContentPage';
import Register from '@/components/auth/Register/Register.vue';
import AuthPage from '@/components/auth/AuthPage';
import RecoverPage from '@/components/auth/RecoverPage';

import User from './user'



import TimelinePage from '@/components/race/TimelinePage';
import RacePage from '@/components/race/RacePage';
import NotFoundComponent from '@/components/pages/NotFound';
import Maintenance from '@/components/pages/Maintenance';

Vue.use(Router);


const router = new Router({
	scrollBehavior() {
		return {x: 0, y: 0}
	},
	routes: [
		{
			path: '/',
			name: 'Home',
			component: HomePage
		},


		//AUTH and REGISTER
		{
			path: '/register',
			name: 'Register',
			component: Register,
			meta: {title: 'page.title.register'}
		},
		{
			path: '/auth',
			name: 'Auth',
			component: AuthPage,
			beforeEnter(to, from, next) {
				if (store.getters.getUserStatus) {
					next({name: 'Home'});
				} else {
					next();
				}
			}
		},
		{
			path: '/logout',
			name: 'Logout',
			beforeEnter(to, from, next) {
				if (store.getters.getUserStatus) {
					store.dispatch('userLogoutAction');
					next(from.path);
					location.reload();
				} else {
					next('/');
				}
			}
		},
		{
			path: '/recover',
			name: 'Recover',
			component: RecoverPage,
			beforeEnter(to, from, next) {
				if (store.getters.getUserStatus) {
					next({name: 'Home'});
				} else {
					next();
				}
			},
			children: [
				{
					path: '/recover/:recoveryCode(\\w+)',
					name: 'RecoverCode',
					component: RecoverPage
				}
			]
		},


		//TIMELINE and RACE
		{
			path: '/timeline',
			name: 'Timeline', //That not menu name! that service name that using internal
			component: TimelinePage,
			children: [
				{
					path: '/timeline/:date(\\d{4,4}-\\d{2,2}-\\d{2,2})',
					name: 'TimelineWithDate',
					component: TimelinePage,
					children: [
						{
							path: 'premium',
							name: 'TimelinePremium',
							component: TimelinePage,

						}
					]
				}
			]
		},
		{
			path: '/race/:meeting_id(\\d+)/:race_id(\\d+)',
			name: 'Race',
			component: RacePage
		},
		{
			path: '/race/:race_id(\\d+)',
			name: 'RaceById',
			component: RacePage
		},
		/*{
			path: '/sport/live',
			name: 'SportLive',
			component: ()=> import('@/components/pages/SevenSportBetting')
		},
		{
			path: '/sport/prematch',
			name: 'SportPreMatch',
			component: ()=> import('@/components/pages/SevenSportBetting')
		},*/


		//USER
		{
			path: '/user',
			component: () => import('@/components/user/UserPage'),
			children: User
		},


		//Bet guide page
		{
			path: '/guide',
			name: 'BetGuide',
			component: () => import('@/components/pages/BetGuide'),
			children: [
				{
					path: '/guide/:betId',
					name: 'BetGuideId',
					component: () => import('@/components/pages/BetGuide')
				}
			]
		},

		//Contact page

		{
			path: '/contact',
			name: 'Contact',
			component: () => import('@/components/pages/ContactPage')
		},

		//Content page

		{
			path: '/page/:pageName',
			name: 'Content',
			component: ContentPage
		},

		//Sell points page page

		{
			path: '/sellpoints',
			name: 'Sellpoints',
			component: () => import('@/components/pages/SellPoints')
		},


		{
			path: '/maintenance',
			name: 'Maintenance',
			component: Maintenance
		},

		//404
		{
			path: '/404',
			name: '404',
			component: NotFoundComponent
		},
		{
			path: '*',
			redirect: '/404'
		}
	]
});

/* ===========================================
              GLOBAL GUARDS
 =========================================== */

router.beforeEach((to, from, next) => {
	if(to.name){
		//Give Vue opportunity to initialize translation function
		Vue.nextTick(()=>{{
			//Wait till translation is initialized
			router.app.$store.state.langPromise.then(()=>{

				let pref = '';
				if(document.location.hostname === 'localhost'){
					pref = 'dev-'
				}
				document.title = pref+router.app.t('page.meta.title.'+to.name.toLowerCase());
			});
		}});

	}



	next();
});
/*router.afterEach((to, from) => {
	//store.commit('endLoad', 'Navigate');//Useless, navigate too fast
});*/

export default router;
